import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../claimCheckPageStyle.js";

const useStyles = makeStyles(styles);

export default function CtaSection({ t }) {
  const classes = useStyles();
  return (
    <div className={classes.ctaSection}>
      <h3 className={classes.ctaTitle}>{t.ctaTitle}</h3>
      <p className={classes.ctaSubtitle}>{t.ctaSubtitle}</p>
      <a href="/contact" className={classes.ctaButton}>
        {t.ctaButton} &rarr;
      </a>
    </div>
  );
}
